import {
  DialogContent,
  Divider,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from '@mui/material';
import moment from 'moment';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { DraggableDialog } from '~/components/Dialogs/components/DraggableDialog';
import { SolaForceDialogTitle } from '~/components/SolaForceDialogTitle';

import { vacationDaysHistoryData } from '../data';

import { useSxStyles } from './useStyles';

type Props = {
  open: boolean;
  onClose: () => void;
  bnEnableVacBank: boolean;
  vacHistoryTableData: vacationDaysHistoryData[];
};

export const VacationDaysHistoryDialog = ({
  open,
  onClose,
  bnEnableVacBank,
  vacHistoryTableData,
}: Props) => {
  const { t } = useTranslation();
  const sxStyles = useSxStyles();

  return (
    <DraggableDialog open={open} onClose={onClose} maxWidth={'lg'}>
      <SolaForceDialogTitle onClose={onClose}>
        {t('laVacBalHistory')}
      </SolaForceDialogTitle>
      <Divider />
      <TableContainer component={DialogContent} sx={sxStyles.tableContainer}>
        <Table size={'small'} stickyHeader aria-label="sticky table">
          <TableHead>
            <TableRow>
              <TableCell>{t('laVacBal')}</TableCell>
              {!bnEnableVacBank ? (
                <>
                  <TableCell>{t('laVacBalExtra')}</TableCell>
                  <TableCell>{t('VExtra supplement1')}</TableCell>
                  <TableCell>{t('Used')}</TableCell>
                  <TableCell>{t('VExtra supplement2')}</TableCell>
                  <TableCell>{t('Used')}</TableCell>
                </>
              ) : (
                <>
                  <TableCell>{t('laVacationBank1')}</TableCell>
                  <TableCell>{t('laVacationBank2')}</TableCell>
                  <TableCell>{t('laVacationBank3')}</TableCell>
                </>
              )}

              <TableCell>{t('laStartDate')}</TableCell>
              <TableCell>{t('laEndDate')}</TableCell>
              <TableCell>{t('laDays')}</TableCell>
              <TableCell>{t('laReason')}</TableCell>
              <TableCell>{t('laInfo')}</TableCell>
              <TableCell>{t('laUpdated')}</TableCell>
              <TableCell>{t('laUpdatedName')}</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {vacHistoryTableData && vacHistoryTableData.length > 0
              ? vacHistoryTableData.map(
                  (data: vacationDaysHistoryData, index: number) => {
                    return (
                      <TableRow key={index}>
                        <TableCell>{data.fVacationBalance}</TableCell>
                        {!bnEnableVacBank ? (
                          <>
                            <TableCell>{data.fVacationBalanceExtra}</TableCell>
                            <TableCell>{data.fVacationBalanceSuppl1}</TableCell>
                            <TableCell>
                              {data.fVacationBalanceSuppl1Spent}
                            </TableCell>
                            <TableCell>{data.fVacationBalanceSuppl2}</TableCell>
                            <TableCell>
                              {data.fVacationBalanceSuppl2Spent}
                            </TableCell>
                          </>
                        ) : (
                          <>
                            <TableCell>{data.fVacationBalanceBank1}</TableCell>
                            <TableCell>{data.fVacationBalanceBank2}</TableCell>
                            <TableCell>{data.fVacationBalanceBank3}</TableCell>
                          </>
                        )}

                        <TableCell>
                          {data.fVacationBalanceDeduction
                            ? moment(
                                data.fVacationBalanceDeduction
                                  .fDeductionStartDate,
                              ).format('DD.MM.YYYY')
                            : ''}
                        </TableCell>
                        <TableCell>
                          {data.fVacationBalanceDeduction
                            ? moment(
                                data.fVacationBalanceDeduction
                                  .fDeductionEndDate,
                              ).format('DD.MM.YYYY')
                            : ''}
                        </TableCell>
                        <TableCell>
                          {data.fVacationBalanceDeduction
                            ? data.fVacationBalanceDeduction.fDeductionDays
                            : ''}
                        </TableCell>
                        <TableCell>
                          {data.fVacationBalanceDeduction
                            ? data.fVacationBalanceDeduction.fDeductionReason
                            : ''}
                        </TableCell>
                        <TableCell>
                          {data.fVacationBalanceDeduction
                            ? data.fVacationBalanceDeduction.fDeductionInfo
                            : ''}
                        </TableCell>
                        <TableCell>
                          {moment(data.fVacationBalanceUpdatedTime).format(
                            'DD.MM.YYYY',
                          )}
                        </TableCell>
                        <TableCell>
                          {data.fVacationBalanceUpdatedName
                            ? data.fVacationBalanceUpdatedName
                            : ''}
                        </TableCell>
                      </TableRow>
                    );
                  },
                )
              : ''}
          </TableBody>
        </Table>
      </TableContainer>
    </DraggableDialog>
  );
};
